import { isDevMode, csvToJSON } from './Helpers';
import { GSHEET_LANGUAGES } from './Config';

const getHostname = (port) => {
	const devModeCheck = isDevMode();
	return devModeCheck ? `localhost${port ? `:${port}` : ''}` : `maps.greenpeace.org`;
}

export const getEndpointUrl = (endpoint) => {
	const devModeCheck = isDevMode();
	const hostname = getHostname(4090);
	const postfix = devModeCheck ? `` : '/api/shared';
	return `//${hostname}${postfix}/${endpoint}`;
}

const getGSheetData = ({ body, callback, all }) => {
	const apiUrl = getEndpointUrl('gsheet-data');
	const cacheLifetime = isDevMode() ? 1 : 36000000;
	fetch(apiUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({...body, cache: cacheLifetime})
	})
	.then(x => x.json())
	.then(r => {
		let json = all ? r?.results?.map((el, i) => csvToJSON(el, r?.sheets?.[i])) : csvToJSON(r);
		callback(all ? {...r, results: json} : json);
	})
}

export const getTranslation = (callback) => {
	getGSheetData({ body: GSHEET_LANGUAGES, callback });
}
